<!-- eslint-disable vue/no-multiple-template-root -->
<template>
  <div :data-app="$isCN ? 'true' : null">
    <router-view></router-view>
  </div>
</template>

<script>
// import NaviGation from '@/views/index/index'
// import Foot from '@/views/foot/index'
export default {
  name: 'App',
  components: {
    // NaviGation,
    // Foot,
  },
}
</script>

<style>
@import '../src/assets/Global.css';
</style>
